import React from "react"
import CMSRender from "aldoo-ra/CMS/cms-render"
import Typography from "aldoo-ra/Typography"
import LanguageBadgesGrid from "../LanguageBadgesGrid"

const renderItem = (section, id) => {
  return (
    <div
      key={id}
      className="w-full flex flex-col justify-center px-4 md:px-px1_l pt-8 md:pt-14 lg:pt-5 lg:pb-[40px] xl:pb-[80px]"
    >
      <LanguageBadgesGrid badges={section.badges} />
    </div>
  )
}

const AppDictionarySection = () => {
  return (
    <CMSRender contentType={"AppDictionarySection"} renderItem={renderItem} />
  )
}

export default AppDictionarySection
